export const ecmEnTranslation = {
    ecm: {
        shell: {
            'loading-text': 'Loading',
        },
    },
};
